module.exports = __webpack_public_path__ + "static/media/Repair-Or-Replace.4bc2e1a7.jpg";